<template>
  <div class="agent-links">
    <div class="section">
      <div class="section-title">{{ $t('proxy.text211') }}</div>
      <div class="section-content">
        <div class="mt-20">
          <el-table
            :data="linksData"
            header-row-class-name="data-header"
            header-cell-class-name="data-header-cell"
            style="width: 100%"
          >
            <el-table-column prop="rulesGroupLevelName" :label="$t('proxy.text212')" width="240" />
            <el-table-column prop="rulesGroupName" :label="$t('proxy.text41')" width="270" />
            <el-table-column prop="h5RegisterUrl" :label="$t('proxy.text211')" width="400">
              <template #default="scope">
                <div class="link-cell">
                  <!-- 拼接 proxyId 和 rulesGroupID 参数到链接 -->
                  <span>{{ `${scope.row.h5RegisterUrl}?proxyId=${scope.row.proxyId}&rulesGroupID=${scope.row.rulesGroupID}` }}</span>
                  <el-button link type="primary" size="small" @click="handleCopy(scope.row)" class="button-text-16">
                    {{ $t('proxy.text30') }}
                  </el-button>
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="proxyId" :label="$t('proxy.text213')" width="200" fixed="right">
              <template #default="scope">
                <el-button link type="primary" size="small" @click="handleView(scope.row)">
                  {{ $t('proxy.text214') }}
                </el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </div>

    <!-- 二维码弹窗 -->
    <el-dialog :title="$t('proxy.text213')" v-model="qrDialogVisible" width="300px">
      <div class="qr-code-container">
        <img :src="qrCodeUrl" alt="QR Code" v-if="qrCodeUrl" />
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="saveQRCode" @click="saveQRCode">{{ $t('myAccount.text118') }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { ref, onMounted } from 'vue';
import apiService from '@/api/request';
import { ElMessage } from 'element-plus';
import { useI18n } from 'vue-i18n';
import QRCode from 'qrcode';
import { useRoute } from 'vue-router';

export default {
  setup() {
    const linksData = ref([]);
    const qrDialogVisible = ref(false);
    const qrCodeUrl = ref('');
    const { t } = useI18n();

    const route = useRoute();

    const fetchPromotionLinks = async (proxyId) => {
      try {
        const response = await apiService.proxyPromotionLinkList({ sproxyId: proxyId });
        linksData.value = response.data.list;
      } catch (error) {
        console.error('获取推广链接失败', error);
      }
    };

    const handleCopy = (row) => {
      const urlWithParams = `${row.h5RegisterUrl}?proxyId=${row.proxyId}&rulesGroupID=${row.rulesGroupID}`;
      navigator.clipboard.writeText(urlWithParams).then(() => {
        ElMessage.success(t('deposit.text24'));
      }).catch(() => {
        ElMessage.error(t('proxy.text215'));
      });
    };

    const handleView = (row) => {
      const urlWithParams = `${row.h5RegisterUrl}?proxyId=${row.proxyId}&rulesGroupID=${row.rulesGroupID}`;
      QRCode.toDataURL(urlWithParams)
        .then((dataUrl) => {
          qrCodeUrl.value = dataUrl;
          qrDialogVisible.value = true;
        })
        .catch((error) => {
          console.error('二维码生成失败:', error);
          ElMessage.error(t('proxy.text218'));
        });
    };

    const saveQRCode = () => {
      const link = document.createElement('a');
      link.href = qrCodeUrl.value;
      link.download = 'qrcode.png';
      link.click();
    };

    onMounted(() => {
      const proxyId = route.query.proxyId || ''; // 获取路由中的 proxyId 参数
      fetchPromotionLinks(proxyId); // 传递 proxyId
    });

    return {
      linksData,
      qrDialogVisible,
      qrCodeUrl,
      handleCopy,
      handleView,
      saveQRCode,
    };
  },
};
</script>

<style scoped>
.link-cell {
  display: flex;
  align-items: center;
}
.link-cell span {
  margin-right: 10px;
}
.qr-code-container {
  text-align: center;
  padding: 20px 0;
}
.dialog-footer {
  display: flex;
  justify-content: flex-end;
  padding: 0 4px 2px; /* 控制右侧和底部的间距 */
}

.saveQRCode {
  width: 80px;
  height: 32px;
  font-size: 16px;
  color: #fff;
  background-color: #51B4F1;
  border: none;
}

.el-button {
  font-size: 16px !important;
}
</style>
